import CookieHelper from '@/services/helpers/CookieHelper'

// Refer-a-friend attribution carrier (VIP-12331). The legacy monolith stamped 1-day httpOnly
// `rc`/`ic` cookies server-side on any page and read them back at registration; the SPA replaces
// that with these FE-owned cookies. Nothing on the backend reads them - the register call sends
// rc/ic explicitly in its body - so this is purely how the SPA remembers a referral link between
// the landing page and whichever registration form (invited page, normal register, OPC guest)
// the visitor finally submits.
const REFERRAL_CODE_KEY = 'rc'
const INVITEE_HASH_KEY = 'ic'
const ATTRIBUTION_TTL_DAYS = 1

const ReferralHelper = {
  /**
   * Persist `rc` (+ optional `ic`) from a route's query, exactly as the legacy plugin did on any
   * page hit. Called on every navigation so a visitor who lands via a referral link and registers
   * elsewhere later is still attributed. Absent params leave any existing capture untouched.
   */
  captureFromQuery(query = {}) {
    const rc = _firstValue(query[REFERRAL_CODE_KEY])
    const ic = _firstValue(query[INVITEE_HASH_KEY])

    if (rc) CookieHelper.setCookie(REFERRAL_CODE_KEY, rc, ATTRIBUTION_TTL_DAYS)
    if (ic) CookieHelper.setCookie(INVITEE_HASH_KEY, ic, ATTRIBUTION_TTL_DAYS)
  },

  /** The captured referral params as a body fragment ({ rc, ic }), omitting whatever is unset. */
  getReferralParams() {
    const params = {}
    const rc = CookieHelper.getCookie(REFERRAL_CODE_KEY)
    const ic = CookieHelper.getCookie(INVITEE_HASH_KEY)

    if (rc) params[REFERRAL_CODE_KEY] = rc
    if (ic) params[INVITEE_HASH_KEY] = ic

    return params
  },

  /** Drop the capture once it has been consumed by a successful registration. */
  clear() {
    CookieHelper.invalidate(REFERRAL_CODE_KEY)
    CookieHelper.invalidate(INVITEE_HASH_KEY)
  }
}

// vue-router query values are string | string[] | null; take the first usable string.
const _firstValue = (value) => {
  if (Array.isArray(value)) return value[0] || ''
  return value || ''
}

export default ReferralHelper
